import { useState } from 'react';
import { UpdatePhoneHeader } from '../../customer/header';
import { Step1, Step2, Step3, Step4, Step5 } from './steps';
import { FullPageLoader } from '../../../component/helper';
import { sendOTP } from '../../api';
import { useLocation, useParams } from 'react-router-dom';

/**
 * PhoneUpdateMain component manages the multi-step phone/email update process for users.
 * Handles progress bar, step navigation, OTP logic, and form state.
 */
const PhoneUpdateMain = () => {
    const { type } = useParams()
    const location = useLocation();
    const [currentStep, setCurrentStep] = useState(1);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const { token, userData } = location.state || {};
    const [formData, setFormData] = useState({
        currentNumber: userData?.phone,
        currentEmail: userData?.email,
        newEmail: '',
        newNumber: '',
    });

    const steps = [
        { number: 1, title: "Current ", subtitle: "Confirm current Details" },
        { number: 2, title: "Verify Current", subtitle: " Verify  current Details" },
        { number: 3, title: "Enter New", subtitle: " new Details" },
        { number: 4, title: "Verify New", subtitle: "Verify new Details" },
        { number: 5, title: "Be Confirmed", subtitle: "Confirm Your Details " }
    ];

    const handleNextStep = () => {
        setCurrentStep(prev => prev + 1);

    };

    const handlePreviousStep = () => {
        setCurrentStep(prev => prev - 1);

    };
    const handleRestart = () => {
        setCurrentStep(1);
    };
    const MobileUpdateOtp = async (number, type, key) => {
        setLoading(true);
        const otpData = {
            mobile: number,
            company_key: userData?.company_key,
            type: type,
        };

        try {
            setError("")
            const response = await sendOTP(otpData);

            if (response.code === 1) {
                if (!key) handleNextStep()
            } else {
                setError(response.message || 'Failed to send OTP');
            }
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };



    const renderProgressBar = () => (
        <div className="mb-5"  >
            <div className="d-flex justify-content-between mb-3">
                {steps.map((step, index) => (
                    <>
                        <div key={step.number} className="text-center flex-grow-1">
                            <div
                                className={`rounded-circle d-flex align-items-center justify-content-center mx-auto mb-1 fw-semibold w-35px  h-35px fs-6 position-relative ${currentStep >= step.number ? "bg-success text-white" : "bg-secondary text-gray-700"}`}
                            >
                                {currentStep > step.number ? '✓' : step.number}
                            </div>
                            <div
                                className={`small  ${currentStep === step.number ? 'fw-semibold ' : 'fw-normal '} ${currentStep >= step.number ? 'text-dark' : 'text-gray-600'}`}
                            >
                                {step.title}
                            </div>
                        </div>
                    </>
                ))}
            </div>

            <div className="progress h-4px rounded bg-secondary" >
                <div
                    className="progress-bar bg-success"
                    role="progressbar"
                    style={{
                        width: `${((currentStep - 1) / (steps.length - 1)) * 100}%`,
                        transition: 'width 0.3s ease'
                    }}
                ></div>
            </div>

        </div>

    );

    const renderCurrentStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <Step1
                        error={error}
                        formData={formData}
                        MobileUpdateOtp={MobileUpdateOtp}
                        type={type}
                        token={token}
                    />
                );
            case 2:
                return (
                    <Step2
                        MobileUpdateOtp={MobileUpdateOtp}
                        formData={formData}
                        onNext={handleNextStep}
                        onPrevious={handlePreviousStep}
                        type={type}
                    />
                );
            case 3:
                return (
                    <Step3
                        userData={userData}
                        error={error}
                        type={type}
                        formData={formData}
                        setFormData={setFormData}
                        MobileUpdateOtp={MobileUpdateOtp}
                        onPrevious={setCurrentStep}
                    />
                );
            case 4:
                return (
                    <Step4
                        MobileUpdateOtp={MobileUpdateOtp}
                        formData={formData}

                        onNext={handleNextStep}
                        onPrevious={handlePreviousStep}
                        type={type}

                    />
                );
            case 5:
                return (
                    <Step5
                        formData={formData}
                        userData={userData}
                        token={token}

                        onPrevious={setCurrentStep}
                        onRestart={handleRestart}
                        type={type}

                    />
                );
            default:
                return null;
        }
    };
    return (

        <div className="d-flex  justify-content-center align-items-center">
            <div className="bg-white d-flex flex-column gap-2  mw-425px  vh-100">
                <UpdatePhoneHeader />
                <div className="px-4 py-3 " >
                    {renderProgressBar()}
                    {renderCurrentStep()}
                </div>
                {loading && <FullPageLoader />}
            </div>
        </div>

    );
};

export default PhoneUpdateMain;




